import { Link } from "react-router-dom";
import { useDiscoverOurServices } from "../../Pregrine/DiscoverOurServices/useDiscoverOurServices";
import styles from "./DiscoverOurService.module.css";
import Slider from "react-slick";
import classNames from "classnames";
import { useRef } from "react";
import Shimmer from "../../components/Shimmer";

const DiscoverOurServices = () => {
  const {
    data,
    loading,
    installationModal,
    setShowInstallationModal,
    setShowTechnicalAssistanceModal,
    setShowFreeDesignModal,
    freeDesignModal,
    technicalAssistanceModal,
  } = useDiscoverOurServices();
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 3,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <section className="pt-3 pb-2 discoverOurServices">
      <div className="container">
        <div className="row">
          <div className={`${styles.title} text-center pb-2`}>
            Discover our Services
          </div>
        </div>
        {installationModal}
        {freeDesignModal}
        {technicalAssistanceModal}
        <div className={styles.discover}>
          <Slider ref={sliderRef} {...settings}>
            {data &&
              data.servicesdata &&
              data.servicesdata.map((item, idx) => (
                <div
                  key={idx}
                  className={styles.item}
                  onClick={() => {
                    if (item?.title.toLowerCase() === "installation services") {
                      setShowInstallationModal(true);
                    } else if (
                      item?.title.toLowerCase() ===
                      "free design services everytime"
                    ) {
                      setShowFreeDesignModal(true);
                    } else {
                      setShowTechnicalAssistanceModal(true);
                    }
                  }}
                >
                  <div className={`${styles["box-item"]} mb-2`}>
                    <img src={item.image} height={54} width={80} />
                    <h5>{item.title}</h5>
                    <div
                      dangerouslySetInnerHTML={{ __html: item.content }}
                      className={styles.content}
                    />
                  </div>
                </div>
              ))}
          </Slider>
          <div className={styles.sliderFooter}>
            <button
              onClick={() => sliderRef?.current?.slickPrev()}
              className={styles.arrow}
            />
            <button
              onClick={() => sliderRef?.current?.slickNext()}
              className={styles.arrow}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscoverOurServices;
